export enum EscalationType {
  unknown = 0,
  documentIdentification = 1,
  dataEntry = 2,
  caseTask = 3,
}